import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function Store() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [location, setLocation] = useState('Pakistan');
  const [sortBy, setSortBy] = useState('new');
  const [priceRange, setPriceRange] = useState([0, 30000]);
  const [showFilters, setShowFilters] = useState(false);

  const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'helmets', name: 'Helmets' },
    { id: 'gloves', name: 'Gloves' },
    { id: 'sleeves', name: 'Sleeves' },
    { id: 'shirts', name: 'Shirts' },
    { id: 'trousers', name: 'Trousers' },
    { id: 'jackets', name: 'Jackets' },
    { id: 'boots', name: 'Boots' },
    { id: 'keychains', name: 'Keychains' },
    { id: 'souvenirs', name: 'Souvenirs' },
    { id: 'gadgets', name: 'Gadgets' },
    { id: 'safety-kits', name: 'Safety Kits' }
  ];

  const products = [
    // Helmets
    { id: 1, name: 'Full Face Helmet Pro', category: 'helmets', price: 'PKR 15,000', image: '/helmet1.jpeg', description: 'Premium full-face helmet with DOT certification and ventilation' },
    { id: 2, name: 'Off-Road Helmet MX', category: 'helmets', price: 'PKR 12,500', image: '/helmet2.jpeg', description: 'Lightweight off-road helmet with superior airflow' },
    { id: 3, name: 'Modular Flip Helmet', category: 'helmets', price: 'PKR 18,000', image: '/helmet3.jpeg', description: 'Versatile flip-up modular helmet for all conditions' },
    { id: 4, name: 'Youth Safety Helmet', category: 'helmets', price: 'PKR 8,500', image: '/helmet4.jpeg', description: 'Certified safety helmet designed for young riders' },
    
    // Gloves
    { id: 5, name: 'Leather Riding Gloves', category: 'gloves', price: 'PKR 2,500', image: '/gloves1.jpeg', description: 'Premium leather gloves with knuckle protection' },
    { id: 6, name: 'Winter Riding Gloves', category: 'gloves', price: 'PKR 3,200', image: '/gloves2.jpeg', description: 'Insulated gloves for cold weather riding' },
    { id: 7, name: 'Touchscreen Gloves', category: 'gloves', price: 'PKR 2,800', image: '/gloves3.jpeg', description: 'Smart gloves with touchscreen compatibility' },
    
    // Sleeves
    { id: 8, name: 'Elbow Protective Sleeves', category: 'sleeves', price: 'PKR 1,800', image: '/sleeve1.jpeg', description: 'Compression sleeves with elbow padding' },
    { id: 9, name: 'Knee Guard Sleeves', category: 'sleeves', price: 'PKR 1,800', image: '/sleeve2.jpeg', description: 'Flexible knee sleeves with impact protection' },
    { id: 10, name: 'Arm Compression Sleeves', category: 'sleeves', price: 'PKR 1,500', image: '/sleeve3.jpeg', description: 'UV protection compression arm sleeves' },
    
    // Shirts
    { id: 11, name: 'Riding Jersey Pro', category: 'shirts', price: 'PKR 3,500', image: '/shirt1.jpeg', description: 'Breathable moisture-wicking riding jersey' },
    { id: 12, name: 'Casual Riding Shirt', category: 'shirts', price: 'PKR 2,800', image: '/shirt2.jpeg', description: 'Comfortable cotton blend riding shirt' },
    { id: 13, name: 'Performance T-Shirt', category: 'shirts', price: 'PKR 2,200', image: '/shirt3.jpeg', description: 'Quick-dry performance riding t-shirt' },
    
    // Trousers
    { id: 14, name: 'Riding Pants Pro', category: 'trousers', price: 'PKR 6,500', image: '/trouser1.jpeg', description: 'Durable riding pants with knee armor' },
    { id: 15, name: 'Cargo Riding Trousers', category: 'trousers', price: 'PKR 5,800', image: '/trouser2.jpeg', description: 'Multi-pocket cargo style riding pants' },
    { id: 16, name: 'Waterproof Riding Pants', category: 'trousers', price: 'PKR 7,200', image: '/trouser3.jpeg', description: 'Fully waterproof riding trousers' },
    
    // Jackets
    { id: 17, name: 'Leather Riding Jacket', category: 'jackets', price: 'PKR 12,500', image: '/jacket1.jpeg', description: 'Premium leather jacket with CE armor' },
    { id: 18, name: 'Textile Touring Jacket', category: 'jackets', price: 'PKR 9,800', image: '/jacket2.jpeg', description: 'All-weather textile touring jacket' },
    { id: 19, name: 'Mesh Summer Jacket', category: 'jackets', price: 'PKR 6,500', image: '/jacket3.jpeg', description: 'Ventilated mesh jacket for hot weather' },
    { id: 20, name: 'Winter Riding Jacket', category: 'jackets', price: 'PKR 11,000', image: '/jacket4.jpeg', description: 'Insulated winter jacket with thermal lining' },
    
    // Boots
    { id: 21, name: 'Adventure Riding Boots', category: 'boots', price: 'PKR 12,000', image: '/boot1.jpeg', description: 'Heavy-duty boots with ankle support' },
    { id: 22, name: 'Short Riding Boots', category: 'boots', price: 'PKR 8,500', image: '/boot2.jpeg', description: 'Casual short boots for urban riding' },
    { id: 23, name: 'Waterproof Touring Boots', category: 'boots', price: 'PKR 14,500', image: '/boot3.jpeg', description: 'Waterproof boots for long-distance touring' },
    
    // Keychains
    { id: 24, name: 'Metal Bike Keychain', category: 'keychains', price: 'PKR 500', image: '/keychains1.jpeg', description: 'Premium metal motorcycle keychain' },
    { id: 25, name: 'Leather Keychain', category: 'keychains', price: 'PKR 800', image: '/keychains2.jpeg', description: 'Handcrafted leather keychain with logo' },
    { id: 26, name: 'Carbon Fiber Keychain', category: 'keychains', price: 'PKR 1,200', image: '/keychains3.jpeg', description: 'Lightweight carbon fiber keychain' },
    
    // Souvenirs
    { id: 27, name: 'Throttle Edge Cap', category: 'souvenirs', price: 'PKR 1,500', image: '/Souvenirs1.jpeg', description: 'Branded baseball cap with embroidered logo' },
    { id: 28, name: 'Bike Model Collectible', category: 'souvenirs', price: 'PKR 2,500', image: '/Souvenirs2.jpg', description: 'Die-cast bike model collectible' },
    { id: 29, name: 'Sticker Pack', category: 'souvenirs', price: 'PKR 600', image: '/Souvenirs3.jpg', description: 'Premium vinyl sticker pack' },
    { id: 30, name: 'Coffee Mug', category: 'souvenirs', price: 'PKR 1,200', image: '/Souvenirs4.jpeg', description: 'Ceramic mug with bike graphics' },
    
    // Gadgets
    { id: 31, name: '4K Action Camera', category: 'gadgets', price: 'PKR 22,000', image: '/gadget1.jpeg', description: '4K action camera with helmet mount' },
    { id: 32, name: 'Bluetooth Headset', category: 'gadgets', price: 'PKR 8,500', image: '/gadgets2.jpeg', description: 'Helmet-mounted Bluetooth communication system' },
    { id: 33, name: 'GPS Tracker Device', category: 'gadgets', price: 'PKR 6,500', image: '/gedget3.jpeg', description: 'Real-time GPS tracking with mobile app' },
    { id: 34, name: 'Phone Mount Pro', category: 'gadgets', price: 'PKR 1,500', image: '/gedgets4.jpeg', description: 'Universal waterproof phone mount' },
    { id: 35, name: 'LED Light Kit', category: 'gadgets', price: 'PKR 4,500', image: '/gadget1.jpeg', description: 'Bright LED auxiliary lights for night riding' },
    { id: 36, name: 'Tire Pressure Monitor', category: 'gadgets', price: 'PKR 5,500', image: '/gadgets2.jpeg', description: 'Digital tire pressure monitoring system' },
    
    // Safety Kits
    { id: 37, name: 'Complete Safety Kit', category: 'safety-kits', price: 'PKR 25,000', image: '/safety1.jpeg', description: 'Full safety gear bundle with helmet and pads' },
    { id: 38, name: 'First Aid Kit Pro', category: 'safety-kits', price: 'PKR 3,500', image: '/safety2.jpeg', description: 'Comprehensive first aid kit for riders' },
    { id: 39, name: 'Bike Maintenance Kit', category: 'safety-kits', price: 'PKR 5,500', image: '/safety3.jpeg', description: 'Essential tools for bike maintenance' },
    { id: 40, name: 'Emergency Road Kit', category: 'safety-kits', price: 'PKR 4,200', image: '/safety1.jpeg', description: 'Emergency kit with tools and supplies' }
  ];

  const openProductModal = (product) => {
    setSelectedProduct(product);
  };

  // Filter and sort products
  const getFilteredAndSortedProducts = (categoryId) => {
    let filtered = categoryId === 'all' 
      ? products 
      : products.filter(p => p.category === categoryId);

    // Apply search filter
    filtered = filtered.filter(p => 
      p.name.toLowerCase().includes(searchQuery.toLowerCase()) || 
      p.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Apply price range filter
    filtered = filtered.filter(p => {
      const price = parseInt(p.price.replace(/[^0-9]/g, ''));
      return price >= priceRange[0] && price <= priceRange[1];
    });

    // Apply sorting
    const sorted = [...filtered].sort((a, b) => {
      const priceA = parseInt(a.price.replace(/[^0-9]/g, ''));
      const priceB = parseInt(b.price.replace(/[^0-9]/g, ''));

      switch(sortBy) {
        case 'low-high':
          return priceA - priceB;
        case 'high-low':
          return priceB - priceA;
        case 'sales':
          return b.id - a.id; // Mock: newer IDs as "sales"
        case 'new':
        default:
          return b.id - a.id; // Newest first
      }
    });

    return sorted;
  };

  const closeModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Hero Banner with Background Image */}
      <div className="mt-16 md:mt-24 relative">
        <div 
          className="relative h-[40vh] md:h-[50vh] bg-cover bg-center"
          style={{
            backgroundImage: 'url(/a13.jpg)',
            backgroundPosition: 'center'
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
          
          <div className="relative h-full flex items-center">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 w-full">
              <div className="max-w-3xl">
                <h1 className="text-4xl md:text-6xl text-white font-bold mb-4">
                  THROTTLE EDGE STORE
                </h1>
                <p className="text-white text-lg md:text-xl leading-relaxed">
                  Your one-stop shop for premium riding gear and accessories. From helmets to boots, 
                  gloves to jackets - we have everything you need for a safe and stylish ride.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Bar Section */}
      <div className="bg-white border-b shadow-sm">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-6">
          <div className="flex flex-col md:flex-row gap-3">
            {/* Location Dropdown */}
            <div className="relative md:w-64">
              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg appearance-none bg-white focus:outline-none focus:border-orange-500"
              >
                <option value="Pakistan">Pakistan</option>
                <option value="Lahore">Lahore</option>
                <option value="Karachi">Karachi</option>
                <option value="Islamabad">Islamabad</option>
                <option value="Rawalpindi">Rawalpindi</option>
                <option value="Faisalabad">Faisalabad</option>
                <option value="Multan">Multan</option>
              </select>
              <svg className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400 pointer-events-none" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </div>

            {/* Search Input */}
            <div className="flex-1 relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Find Helmets, Jackets, Gloves and more..."
                className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-black"
              />
              <svg className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>

            {/* Search Button */}
            <button className="bg-black text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors flex items-center justify-center gap-2">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
              Search
            </button>
          </div>
        </div>
      </div>

      {/* Category Filter - Sticky */}
      <div className="bg-white shadow-sm sticky top-16 md:top-24 z-40">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4">
          <div className="flex flex-wrap gap-3">
            {categories.filter(cat => cat.id !== 'all').map(cat => (
              <button
                key={cat.id}
                onClick={() => {
                  const element = document.getElementById(cat.id);
                  element?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="px-6 py-2 rounded-full font-semibold text-sm transition-all bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Category Sections */}
      <div className="py-8 md:py-12 bg-gray-50">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-6">
            
            {/* Sidebar Filters */}
            <div className="lg:w-64 flex-shrink-0">
              {/* Mobile Filter Toggle */}
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="lg:hidden w-full bg-white border border-gray-300 px-4 py-3 rounded-lg font-semibold mb-4 flex items-center justify-between"
              >
                <span>Filters</span>
                <svg className={`w-5 h-5 transform transition-transform ${showFilters ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              <div className={`bg-white rounded-lg border border-gray-200 p-6 space-y-6 ${showFilters ? 'block' : 'hidden lg:block'}`}>
                {/* Sort By */}
                <div>
                  <h3 className="font-bold text-lg mb-4">Sort By</h3>
                  <div className="space-y-2">
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="sort"
                        value="new"
                        checked={sortBy === 'new'}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="mr-3"
                      />
                      <span className="text-gray-700">New Arrivals</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="sort"
                        value="low-high"
                        checked={sortBy === 'low-high'}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="mr-3"
                      />
                      <span className="text-gray-700">Price: Low to High</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="sort"
                        value="high-low"
                        checked={sortBy === 'high-low'}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="mr-3"
                      />
                      <span className="text-gray-700">Price: High to Low</span>
                    </label>
                    <label className="flex items-center cursor-pointer">
                      <input
                        type="radio"
                        name="sort"
                        value="sales"
                        checked={sortBy === 'sales'}
                        onChange={(e) => setSortBy(e.target.value)}
                        className="mr-3"
                      />
                      <span className="text-gray-700">Best Sales</span>
                    </label>
                  </div>
                </div>

                {/* Price Range */}
                <div className="border-t pt-6">
                  <h3 className="font-bold text-lg mb-4">Price Range</h3>
                  <div className="space-y-4">
                    <div className="flex items-center justify-between text-sm text-gray-700">
                      <span>PKR {priceRange[0].toLocaleString()}</span>
                      <span>PKR {priceRange[1].toLocaleString()}</span>
                    </div>
                    <input
                      type="range"
                      min="0"
                      max="30000"
                      step="1000"
                      value={priceRange[1]}
                      onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value)])}
                      className="w-full"
                    />
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-xs text-gray-600 mb-1 block">Min</label>
                        <input
                          type="number"
                          value={priceRange[0]}
                          onChange={(e) => setPriceRange([parseInt(e.target.value) || 0, priceRange[1]])}
                          className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                          placeholder="Min"
                        />
                      </div>
                      <div>
                        <label className="text-xs text-gray-600 mb-1 block">Max</label>
                        <input
                          type="number"
                          value={priceRange[1]}
                          onChange={(e) => setPriceRange([priceRange[0], parseInt(e.target.value) || 30000])}
                          className="w-full border border-gray-300 rounded px-3 py-2 text-sm"
                          placeholder="Max"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Reset Filters */}
                <button
                  onClick={() => {
                    setSortBy('new');
                    setPriceRange([0, 30000]);
                  }}
                  className="w-full border-2 border-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-100 transition-colors font-semibold text-sm"
                >
                  Reset Filters
                </button>
              </div>
            </div>

            {/* Products Section */}
            <div className="flex-1">
              {categories.filter(cat => cat.id !== 'all').map(category => {
                const categoryProducts = getFilteredAndSortedProducts(category.id);

                if (categoryProducts.length === 0) return null;

                return (
                  <div key={category.id} id={category.id} className="mb-12 scroll-mt-32">
                    {/* Section Header */}
                    <div className="flex items-center justify-between mb-6">
                      <h2 className="text-3xl font-bold text-gray-800">
                        {category.name}
                      </h2>
                      <span className="text-gray-500 text-lg">
                        {categoryProducts.length} items
                      </span>
                    </div>

                    {/* Products Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                      {categoryProducts.map(product => (
                        <div 
                          key={product.id}
                          className="bg-white rounded-lg border border-gray-200 hover:shadow-xl transition-shadow cursor-pointer overflow-hidden"
                          onClick={() => openProductModal(product)}
                        >
                          <div className="relative">
                            <img 
                              src={product.image} 
                              alt={product.name}
                              className="w-full h-48 object-cover"
                            />
                            <button className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center hover:bg-gray-100">
                              <svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                              </svg>
                            </button>
                            <div className="absolute bottom-3 left-3 bg-white px-2 py-1 rounded text-xs font-semibold text-gray-700">
                              FEATURED
                            </div>
                          </div>
                          
                          <div className="p-3">
                            <div className="flex items-start justify-between mb-2">
                              <h3 className="font-bold text-lg text-gray-900">
                                {product.price}
                              </h3>
                            </div>
                            
                            <h4 className="text-gray-800 font-medium mb-1 line-clamp-1">
                              {product.name}
                            </h4>
                            
                            <p className="text-gray-500 text-xs mb-2 line-clamp-1">
                              {product.description}
                            </p>
                            
                            <div className="flex items-center justify-between text-xs text-gray-500 pt-2 border-t">
                              <span>Throttle Edge</span>
                              <span>2 days ago</span>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Store Info Section */}
      <div className="bg-white py-12 md:py-16 border-t">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Quality Guaranteed</h3>
              <p className="text-gray-600">All products are certified and tested</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Secure Payment</h3>
              <p className="text-gray-600">Safe and secure payment options</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">24/7 Support</h3>
              <p className="text-gray-600">Contact us anytime for assistance</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      {/* Product Detail Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto relative">
            <button 
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-3xl font-light z-10"
            >
              ×
            </button>

            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Product Image */}
                <div>
                  <img 
                    src={selectedProduct.image} 
                    alt={selectedProduct.name}
                    className="w-full h-96 object-cover rounded-lg"
                  />
                </div>

                {/* Product Details */}
                <div>
                  <div className="inline-block bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-xs font-bold mb-4">
                    {categories.find(c => c.id === selectedProduct.category)?.name}
                  </div>
                  
                  <h2 className="text-3xl font-bold text-gray-800 mb-4">
                    {selectedProduct.name}
                  </h2>
                  
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    {selectedProduct.description}
                  </p>

                  <div className="bg-gray-50 p-6 rounded-lg mb-6">
                    <div className="flex items-baseline gap-2 mb-4">
                      <span className="text-4xl font-bold text-gray-900">
                        {selectedProduct.price}
                      </span>
                      <span className="text-gray-500 line-through">
                        PKR {parseInt(selectedProduct.price.replace(/[^0-9]/g, '')) + 2000}
                      </span>
                    </div>
                    <p className="text-green-600 font-semibold">In Stock</p>
                  </div>

                  <div className="space-y-3 mb-6">
                    <div className="flex items-center gap-2 text-gray-700">
                      <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Free delivery on orders over PKR 5,000</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700">
                      <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>7-day return policy</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-700">
                      <svg className="w-5 h-5 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      <span>Warranty included</span>
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <button className="flex-1 bg-black text-white py-4 rounded-lg font-bold hover:bg-gray-800 transition-colors">
                      Add to Cart
                    </button>
                    <button className="flex-1 border-2 border-black text-black py-4 rounded-lg font-bold hover:bg-gray-100 transition-colors">
                      Buy Now
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Store;
